/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_PriceListEntityKinds {
    Customer = 10,
    CustomerPriceGroup = 20,
    Global = 30,
    All = 40,
}
